/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис предоставляет возможность авторизации
 */

/**
 * Сервис авторизации пользователей
 */
export class AuthorizationServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод авторизации по ОТП-коду.
   * Не требует авторизации
   */
  PostAuthorizationLogin = (req: PostAuthorizationLoginRequestDto, init?: RequestInit): Promise<PostAuthorizationLoginResponseDto> => {
    return fm.request<PostAuthorizationLoginRequestDto, PostAuthorizationLoginResponseDto>(`${this.host}/identity/api/v1/authorization/login`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод запроса ОТП-кода.
   * Не требует авторизации
   */
  PostAuthorizationSendCode = (req?: PostAuthorizationSendCodeRequestDto, init?: RequestInit): Promise<PostAuthorizationSendCodeResponseDto> => {
    return fm.request<PostAuthorizationSendCodeRequestDto, PostAuthorizationSendCodeResponseDto>(`${this.host}/identity/api/v1/authorization/send_code`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод авторизации по паролю.
   * Не требует авторизации
   */
  PostAuthorizationLoginByPassword = (req: PostAuthorizationLoginByPasswordRequestDto, init?: RequestInit): Promise<PostAuthorizationLoginByPasswordResponseDto> => {
    return fm.request<PostAuthorizationLoginByPasswordRequestDto, PostAuthorizationLoginByPasswordResponseDto>(`${this.host}/identity/api/v1/authorization/login_by_password`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Капча
 */
export type CaptchaRequestDto = {
  /**
   * Идентификатор капчи
   */
  id: string
  /**
   * Ссылка на капчу
   */
  url: string
}
/**
 * Капча
 */
export type CaptchaResponseDto = {
  /**
   * Идентификатор капчи
   */
  id: string
  /**
   * Ссылка на капчу
   */
  url: string
}
/**
 * Ответ на капчу
 */
export type CaptchaAnswerRequestDto = {
  /**
   * Идентификатор капчи
   */
  id: string
  /**
   * Ответ на капчу
   */
  code: string
}
/**
 * Ответ на капчу
 */
export type CaptchaAnswerResponseDto = {
  /**
   * Идентификатор капчи
   */
  id: string
  /**
   * Ответ на капчу
   */
  code: string
}
/**
 * Ошибка ответа на капчу
 */
export type CaptchaAnswerErrorRequestDto = {
  /**
   * Капча
   */
  captcha?: CaptchaRequestDto | null
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Некорректный ответ на капчу
   */
  readonly wrongAnswer: CaptchaAnswerErrorWrongAnswerRequestDto
}>
/**
 * Ошибка ответа на капчу
 */
export type CaptchaAnswerErrorResponseDto = {
  /**
   * Капча
   */
  captcha: CaptchaResponseDto | null
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Некорректный ответ на капчу
   */
  readonly wrongAnswer: CaptchaAnswerErrorWrongAnswerResponseDto
}>
/**
 * Некорректный ответ на капчу
 */
export type CaptchaAnswerErrorWrongAnswerRequestDto = {
}
/**
 * Некорректный ответ на капчу
 */
export type CaptchaAnswerErrorWrongAnswerResponseDto = {
}
/**
 * Ошибки сервисов ключа
 */
export type KeyErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка создания пользователя
   */
  readonly userCreation: KeyErrorUserCreationRequestDto
  /**
   * Пользователь не найден в Ключе
   */
  readonly userNotFound: KeyErrorUserNotFoundRequestDto
  /**
   * Пользователь заблокирован
   */
  readonly userIsBlocked: KeyErrorUserIsBlockedRequestDto
}>
/**
 * Ошибки сервисов ключа
 */
export type KeyErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка создания пользователя
   */
  readonly userCreation: KeyErrorUserCreationResponseDto
  /**
   * Пользователь не найден в Ключе
   */
  readonly userNotFound: KeyErrorUserNotFoundResponseDto
  /**
   * Пользователь заблокирован
   */
  readonly userIsBlocked: KeyErrorUserIsBlockedResponseDto
}>
/**
 * Ошибка создания пользователя
 */
export type KeyErrorUserCreationRequestDto = {
}
/**
 * Ошибка создания пользователя
 */
export type KeyErrorUserCreationResponseDto = {
}
/**
 * Пользователь заблокирован
 */
export type KeyErrorUserIsBlockedRequestDto = {
}
/**
 * Пользователь заблокирован
 */
export type KeyErrorUserIsBlockedResponseDto = {
}
/**
 * Пользователь не найден в Ключе
 */
export type KeyErrorUserNotFoundRequestDto = {
}
/**
 * Пользователь не найден в Ключе
 */
export type KeyErrorUserNotFoundResponseDto = {
}
/**
 * Информация о вводе ОТП-кода
 */
export type OtpCodeRequestDto = {
  /**
   * Идентификатор ОТП-кода
   */
  codeId: string
  /**
   * Время в секундах, оставшееся до возможности отправки следующего кода
   */
  timeout: number
}
/**
 * Информация о вводе ОТП-кода
 */
export type OtpCodeResponseDto = {
  /**
   * Идентификатор ОТП-кода
   */
  codeId: string
  /**
   * Время в секундах, оставшееся до возможности отправки следующего кода
   */
  timeout: number
}
/**
 * Ошибка ответа на капчу
 */
export type OtpCodeErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Код истек
   */
  readonly lifeTimeExpired: OtpCodeErrorLifeTimeExpiredRequestDto
  /**
   * Попыток больше нет
   */
  readonly noAttempts: OtpCodeErrorNoAttemptsRequestDto
  /**
   * Адрес для отправки кода не найден.
   * В текущей реализации, эту ошибку невозможно получить
   */
  readonly addressNotFound: OtpCodeErrorAddressNotFoundRequestDto
  /**
   * Неправильный ОТП-код
   */
  readonly invalidCode: OtpCodeErrorInvalidCodeRequestDto
}>
/**
 * Ошибка ответа на капчу
 */
export type OtpCodeErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Код истек
   */
  readonly lifeTimeExpired: OtpCodeErrorLifeTimeExpiredResponseDto
  /**
   * Попыток больше нет
   */
  readonly noAttempts: OtpCodeErrorNoAttemptsResponseDto
  /**
   * Адрес для отправки кода не найден.
   * В текущей реализации, эту ошибку невозможно получить
   */
  readonly addressNotFound: OtpCodeErrorAddressNotFoundResponseDto
  /**
   * Неправильный ОТП-код
   */
  readonly invalidCode: OtpCodeErrorInvalidCodeResponseDto
}>
/**
 * Адрес для отправки кода не найден
 */
export type OtpCodeErrorAddressNotFoundRequestDto = {
}
/**
 * Адрес для отправки кода не найден
 */
export type OtpCodeErrorAddressNotFoundResponseDto = {
}
/**
 * Неправильный ОТП-код
 */
export type OtpCodeErrorInvalidCodeRequestDto = {
}
/**
 * Неправильный ОТП-код
 */
export type OtpCodeErrorInvalidCodeResponseDto = {
}
/**
 * Код истек
 */
export type OtpCodeErrorLifeTimeExpiredRequestDto = {
}
/**
 * Код истек
 */
export type OtpCodeErrorLifeTimeExpiredResponseDto = {
}
/**
 * Попыток больше нет
 */
export type OtpCodeErrorNoAttemptsRequestDto = {
}
/**
 * Попыток больше нет
 */
export type OtpCodeErrorNoAttemptsResponseDto = {
}
/**
 * Запрос на авторизацию по паролю
 */
export type PostAuthorizationLoginByPasswordRequestDto = {
  /**
   * Пароль
   */
  password: string
  /**
   * Ответ на капчу
   */
  captchaAnswer?: CaptchaAnswerRequestDto | null
}
/**
 * type
 */
& fm.OptionalOneOf<{
  /**
   * Номер телефона
   */
  readonly phoneNumber: string
  /**
   * Электронная почта
   */
  readonly email: string
  /**
   * Логин
   */
  readonly login: string
}>
/**
 * Ответ на запрос об авторизации по паролю пользователя
 */
export type PostAuthorizationLoginByPasswordResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Токен пользователя
   */
  readonly data: UserTokenResponseDto
  /**
   * Ошибка
   */
  readonly error: PostAuthorizationLoginByPasswordResponseErrorDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostAuthorizationLoginByPasswordResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка капчи
   */
  readonly captchaAnswer: CaptchaAnswerErrorRequestDto
  /**
   * Ошибка из ССО
   */
  readonly sso: SsoErrorRequestDto
  /**
   * Ошибка из сервисов ключа
   */
  readonly key: KeyErrorRequestDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostAuthorizationLoginByPasswordResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка капчи
   */
  readonly captchaAnswer: CaptchaAnswerErrorResponseDto
  /**
   * Ошибка из ССО
   */
  readonly sso: SsoErrorResponseDto
  /**
   * Ошибка из сервисов ключа
   */
  readonly key: KeyErrorResponseDto
}>
/**
 * Запрос на авторизацию по ОТП-коду
 */
export type PostAuthorizationLoginRequestDto = {
  /**
   * Идентификатор ОТП-кода
   */
  codeId: string
  /**
   * Значение ОТП-кода
   */
  code: string
}
/**
 * Ответ на запрос об авторизации пользователя
 */
export type PostAuthorizationLoginResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Токен пользователя
   */
  readonly data: UserTokenResponseDto
  /**
   * Ошибка
   */
  readonly error: PostAuthorizationLoginResponseErrorDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostAuthorizationLoginResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка отп-кода
   */
  readonly otpCode: OtpCodeErrorRequestDto
  /**
   * Ошибка из ССО
   */
  readonly sso: SsoErrorRequestDto
  /**
   * Ошибка из сервисов ключа
   */
  readonly key: KeyErrorRequestDto
}>
/**
 * Ошибка запроса авторизации пользователя
 */
export type PostAuthorizationLoginResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка отп-кода
   */
  readonly otpCode: OtpCodeErrorResponseDto
  /**
   * Ошибка из ССО
   */
  readonly sso: SsoErrorResponseDto
  /**
   * Ошибка из сервисов ключа
   */
  readonly key: KeyErrorResponseDto
}>
/**
 * Запрос на отправку ОТП-кода
 */
export type PostAuthorizationSendCodeRequestDto = {
  /**
   * Ответ на капчу
   */
  captchaAnswer?: CaptchaAnswerRequestDto | null
}
/**
 * otp_text
 */
& fm.OptionalOneOf<{
  /**
   * Номер телефона
   */
  readonly phoneNumber: string
}>
/**
 * Ответ на запрос на отправку ОТП-кода
 */
export type PostAuthorizationSendCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Информация об ОТП-коде
   */
  readonly data: OtpCodeResponseDto
  /**
   * Ошибка
   */
  readonly error: PostAuthorizationSendCodeResponseErrorDto
}>
/**
 * Ошибка запроса на отправку ОТП-кода
 */
export type PostAuthorizationSendCodeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка ответа с капчей
   */
  readonly captchaAnswer: CaptchaAnswerErrorRequestDto
  /**
   * Ошибка из ССО
   */
  readonly sso: SsoErrorRequestDto
}>
/**
 * Ошибка запроса на отправку ОТП-кода
 */
export type PostAuthorizationSendCodeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка ответа с капчей
   */
  readonly captchaAnswer: CaptchaAnswerErrorResponseDto
  /**
   * Ошибка из ССО
   */
  readonly sso: SsoErrorResponseDto
}>
/**
 * Ошибки из ССО
 */
export type SsoErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Пользователь временно заблокирован
   */
  readonly userIsTemporaryBlocked: SsoErrorUserIsTemporaryBlockedRequestDto
  /**
   * Пользователь не найден
   */
  readonly userNotFound: SsoErrorUserNotFoundRequestDto
  /**
   * Неверный пароль
   */
  readonly wrongCredentials: SsoErrorWrongCredentialsRequestDto
  /**
   * Пользователь заблокирован
   */
  readonly userIsBlocked: SsoErrorUserIsBlockedRequestDto
  /**
   * Превышен интервал отправки ОТП-кодов
   */
  readonly intervalExceeded: SsoErrorIntervalExceededRequestDto
}>
/**
 * Ошибки из ССО
 */
export type SsoErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Пользователь временно заблокирован
   */
  readonly userIsTemporaryBlocked: SsoErrorUserIsTemporaryBlockedResponseDto
  /**
   * Пользователь не найден
   */
  readonly userNotFound: SsoErrorUserNotFoundResponseDto
  /**
   * Неверный пароль
   */
  readonly wrongCredentials: SsoErrorWrongCredentialsResponseDto
  /**
   * Пользователь заблокирован
   */
  readonly userIsBlocked: SsoErrorUserIsBlockedResponseDto
  /**
   * Превышен интервал отправки ОТП-кодов
   */
  readonly intervalExceeded: SsoErrorIntervalExceededResponseDto
}>
/**
 * Превышен интервал отправки ОТП-кодов
 */
export type SsoErrorIntervalExceededRequestDto = {
}
/**
 * Превышен интервал отправки ОТП-кодов
 */
export type SsoErrorIntervalExceededResponseDto = {
}
/**
 * Пользователь заблокирован
 */
export type SsoErrorUserIsBlockedRequestDto = {
}
/**
 * Пользователь заблокирован
 */
export type SsoErrorUserIsBlockedResponseDto = {
}
/**
 * Пользователь временно заблокирован
 */
export type SsoErrorUserIsTemporaryBlockedRequestDto = {
}
/**
 * Пользователь временно заблокирован
 */
export type SsoErrorUserIsTemporaryBlockedResponseDto = {
}
/**
 * Пользователь не найден
 */
export type SsoErrorUserNotFoundRequestDto = {
}
/**
 * Пользователь не найден
 */
export type SsoErrorUserNotFoundResponseDto = {
}
/**
 * Неверный пароль
 */
export type SsoErrorWrongCredentialsRequestDto = {
  /**
   * Капча
   */
  captcha?: CaptchaRequestDto | null
}
/**
 * Неверный пароль
 */
export type SsoErrorWrongCredentialsResponseDto = {
  /**
   * Капча
   */
  captcha: CaptchaResponseDto | null
}
/**
 * Информация о токене пользователя
 */
export type UserTokenRequestDto = {
  /**
   * Токен
   */
  accessToken: string
  /**
   * Окончание действия токена
   */
  expiredAt: string
}
/**
 * Информация о токене пользователя
 */
export type UserTokenResponseDto = {
  /**
   * Токен
   */
  accessToken: string
  /**
   * Окончание действия токена
   */
  expiredAt: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Капча
   */
  "Captcha": {
    "kind": "class",
    "text": "Капча",
    "fields": {
      /**
       * Идентификатор капчи
       */
      "id": {
        "type": "string",
        "text": "Идентификатор капчи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ссылка на капчу
       */
      "url": {
        "type": "string",
        "text": "Ссылка на капчу",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на капчу
   */
  "CaptchaAnswer": {
    "kind": "class",
    "text": "Ответ на капчу",
    "fields": {
      /**
       * Идентификатор капчи
       */
      "id": {
        "type": "string",
        "text": "Идентификатор капчи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ответ на капчу
       */
      "code": {
        "type": "string",
        "text": "Ответ на капчу",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка ответа на капчу
   */
  "CaptchaAnswer.Error": {
    "kind": "class",
    "text": "Ошибка ответа на капчу",
    "fields": {
      /**
       * Некорректный ответ на капчу
       */
      "wrongAnswer": {
        "type": "CaptchaAnswer.Error.WrongAnswer",
        "text": "Некорректный ответ на капчу",
      },
      /**
       * Капча
       */
      "captcha": {
        "type": "Captcha",
        "text": "Капча",
      },
    },
  },
  /**
   * Некорректный ответ на капчу
   */
  "CaptchaAnswer.Error.WrongAnswer": {
    "kind": "class",
    "text": "Некорректный ответ на капчу",
  },
  /**
   * Ошибки сервисов ключа
   */
  "KeyError": {
    "kind": "class",
    "text": "Ошибки сервисов ключа",
    "fields": {
      /**
       * Ошибка создания пользователя
       */
      "userCreation": {
        "type": "KeyError.UserCreation",
        "text": "Ошибка создания пользователя",
      },
      /**
       * Пользователь не найден в Ключе
       */
      "userNotFound": {
        "type": "KeyError.UserNotFound",
        "text": "Пользователь не найден в Ключе",
      },
      /**
       * Пользователь заблокирован
       */
      "userIsBlocked": {
        "type": "KeyError.UserIsBlocked",
        "text": "Пользователь заблокирован",
      },
    },
  },
  /**
   * Ошибка создания пользователя
   */
  "KeyError.UserCreation": {
    "kind": "class",
    "text": "Ошибка создания пользователя",
  },
  /**
   * Пользователь заблокирован
   */
  "KeyError.UserIsBlocked": {
    "kind": "class",
    "text": "Пользователь заблокирован",
  },
  /**
   * Пользователь не найден в Ключе
   */
  "KeyError.UserNotFound": {
    "kind": "class",
    "text": "Пользователь не найден в Ключе",
  },
  /**
   * Информация о вводе ОТП-кода
   */
  "OtpCode": {
    "kind": "class",
    "text": "Информация о вводе ОТП-кода",
    "fields": {
      /**
       * Идентификатор ОТП-кода
       */
      "codeId": {
        "type": "string",
        "text": "Идентификатор ОТП-кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Время в секундах, оставшееся до возможности отправки следующего кода
       */
      "timeout": {
        "type": "int32",
        "text": "Время в секундах, оставшееся до возможности отправки следующего кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка ответа на капчу
   */
  "OtpCode.Error": {
    "kind": "class",
    "text": "Ошибка ответа на капчу",
    "fields": {
      /**
       * Код истек
       */
      "lifeTimeExpired": {
        "type": "OtpCode.Error.LifeTimeExpired",
        "text": "Код истек",
      },
      /**
       * Попыток больше нет
       */
      "noAttempts": {
        "type": "OtpCode.Error.NoAttempts",
        "text": "Попыток больше нет",
      },
      /**
       * Адрес для отправки кода не найден.
       * В текущей реализации, эту ошибку невозможно получить
       */
      "addressNotFound": {
        "type": "OtpCode.Error.AddressNotFound",
        "text": "Адрес для отправки кода не найден.\nВ текущей реализации, эту ошибку невозможно получить",
      },
      /**
       * Неправильный ОТП-код
       */
      "invalidCode": {
        "type": "OtpCode.Error.InvalidCode",
        "text": "Неправильный ОТП-код",
      },
    },
  },
  /**
   * Адрес для отправки кода не найден
   */
  "OtpCode.Error.AddressNotFound": {
    "kind": "class",
    "text": "Адрес для отправки кода не найден",
  },
  /**
   * Неправильный ОТП-код
   */
  "OtpCode.Error.InvalidCode": {
    "kind": "class",
    "text": "Неправильный ОТП-код",
  },
  /**
   * Код истек
   */
  "OtpCode.Error.LifeTimeExpired": {
    "kind": "class",
    "text": "Код истек",
  },
  /**
   * Попыток больше нет
   */
  "OtpCode.Error.NoAttempts": {
    "kind": "class",
    "text": "Попыток больше нет",
  },
  /**
   * Запрос на авторизацию по паролю
   */
  "PostAuthorizationLoginByPasswordRequest": {
    "kind": "class",
    "text": "Запрос на авторизацию по паролю",
    "fields": {
      /**
       * Номер телефона
       */
      "phoneNumber": {
        "type": "string",
        "text": "Номер телефона",
      },
      /**
       * Электронная почта
       */
      "email": {
        "type": "string",
        "text": "Электронная почта",
      },
      /**
       * Логин
       */
      "login": {
        "type": "string",
        "text": "Логин",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ответ на капчу
       */
      "captchaAnswer": {
        "type": "CaptchaAnswer",
        "text": "Ответ на капчу",
      },
    },
  },
  /**
   * Ответ на запрос об авторизации по паролю пользователя
   */
  "PostAuthorizationLoginByPasswordResponse": {
    "kind": "class",
    "text": "Ответ на запрос об авторизации по паролю пользователя",
    "fields": {
      /**
       * Токен пользователя
       */
      "data": {
        "type": "UserToken",
        "text": "Токен пользователя",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAuthorizationLoginByPasswordResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса авторизации пользователя
   */
  "PostAuthorizationLoginByPasswordResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса авторизации пользователя",
    "fields": {
      /**
       * Ошибка капчи
       */
      "captchaAnswer": {
        "type": "CaptchaAnswer.Error",
        "text": "Ошибка капчи",
      },
      /**
       * Ошибка из ССО
       */
      "sso": {
        "type": "SsoError",
        "text": "Ошибка из ССО",
      },
      /**
       * Ошибка из сервисов ключа
       */
      "key": {
        "type": "KeyError",
        "text": "Ошибка из сервисов ключа",
      },
    },
  },
  /**
   * Запрос на авторизацию по ОТП-коду
   */
  "PostAuthorizationLoginRequest": {
    "kind": "class",
    "text": "Запрос на авторизацию по ОТП-коду",
    "fields": {
      /**
       * Идентификатор ОТП-кода
       */
      "codeId": {
        "type": "string",
        "text": "Идентификатор ОТП-кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ОТП-кода
       */
      "code": {
        "type": "string",
        "text": "Значение ОТП-кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос об авторизации пользователя
   */
  "PostAuthorizationLoginResponse": {
    "kind": "class",
    "text": "Ответ на запрос об авторизации пользователя",
    "fields": {
      /**
       * Токен пользователя
       */
      "data": {
        "type": "UserToken",
        "text": "Токен пользователя",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAuthorizationLoginResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса авторизации пользователя
   */
  "PostAuthorizationLoginResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса авторизации пользователя",
    "fields": {
      /**
       * Ошибка отп-кода
       */
      "otpCode": {
        "type": "OtpCode.Error",
        "text": "Ошибка отп-кода",
      },
      /**
       * Ошибка из ССО
       */
      "sso": {
        "type": "SsoError",
        "text": "Ошибка из ССО",
      },
      /**
       * Ошибка из сервисов ключа
       */
      "key": {
        "type": "KeyError",
        "text": "Ошибка из сервисов ключа",
      },
    },
  },
  /**
   * Запрос на отправку ОТП-кода
   */
  "PostAuthorizationSendCodeRequest": {
    "kind": "class",
    "text": "Запрос на отправку ОТП-кода",
    "fields": {
      /**
       * Номер телефона
       */
      "phoneNumber": {
        "type": "string",
        "text": "Номер телефона",
      },
      /**
       * Ответ на капчу
       */
      "captchaAnswer": {
        "type": "CaptchaAnswer",
        "text": "Ответ на капчу",
      },
    },
  },
  /**
   * Ответ на запрос на отправку ОТП-кода
   */
  "PostAuthorizationSendCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос на отправку ОТП-кода",
    "fields": {
      /**
       * Информация об ОТП-коде
       */
      "data": {
        "type": "OtpCode",
        "text": "Информация об ОТП-коде",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostAuthorizationSendCodeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на отправку ОТП-кода
   */
  "PostAuthorizationSendCodeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на отправку ОТП-кода",
    "fields": {
      /**
       * Ошибка ответа с капчей
       */
      "captchaAnswer": {
        "type": "CaptchaAnswer.Error",
        "text": "Ошибка ответа с капчей",
      },
      /**
       * Ошибка из ССО
       */
      "sso": {
        "type": "SsoError",
        "text": "Ошибка из ССО",
      },
    },
  },
  /**
   * Ошибки из ССО
   */
  "SsoError": {
    "kind": "class",
    "text": "Ошибки из ССО",
    "fields": {
      /**
       * Пользователь временно заблокирован
       */
      "userIsTemporaryBlocked": {
        "type": "SsoError.UserIsTemporaryBlocked",
        "text": "Пользователь временно заблокирован",
      },
      /**
       * Пользователь не найден
       */
      "userNotFound": {
        "type": "SsoError.UserNotFound",
        "text": "Пользователь не найден",
      },
      /**
       * Неверный пароль
       */
      "wrongCredentials": {
        "type": "SsoError.WrongCredentials",
        "text": "Неверный пароль",
      },
      /**
       * Пользователь заблокирован
       */
      "userIsBlocked": {
        "type": "SsoError.UserIsBlocked",
        "text": "Пользователь заблокирован",
      },
      /**
       * Превышен интервал отправки ОТП-кодов
       */
      "intervalExceeded": {
        "type": "SsoError.IntervalExceeded",
        "text": "Превышен интервал отправки ОТП-кодов",
      },
    },
  },
  /**
   * Превышен интервал отправки ОТП-кодов
   */
  "SsoError.IntervalExceeded": {
    "kind": "class",
    "text": "Превышен интервал отправки ОТП-кодов",
  },
  /**
   * Пользователь заблокирован
   */
  "SsoError.UserIsBlocked": {
    "kind": "class",
    "text": "Пользователь заблокирован",
  },
  /**
   * Пользователь временно заблокирован
   */
  "SsoError.UserIsTemporaryBlocked": {
    "kind": "class",
    "text": "Пользователь временно заблокирован",
  },
  /**
   * Пользователь не найден
   */
  "SsoError.UserNotFound": {
    "kind": "class",
    "text": "Пользователь не найден",
  },
  /**
   * Неверный пароль
   */
  "SsoError.WrongCredentials": {
    "kind": "class",
    "text": "Неверный пароль",
    "fields": {
      /**
       * Капча
       */
      "captcha": {
        "type": "Captcha",
        "text": "Капча",
      },
    },
  },
  /**
   * Информация о токене пользователя
   */
  "UserToken": {
    "kind": "class",
    "text": "Информация о токене пользователя",
    "fields": {
      /**
       * Токен
       */
      "accessToken": {
        "type": "string",
        "text": "Токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Окончание действия токена
       */
      "expiredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Окончание действия токена",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}